module.exports = __webpack_public_path__ + "media/images/poster-829364871f2208d3f3c693ac619b9ff5.jpg";